import { React } from "react";
import "./Footer.css"; // Import footer styles
import { useNavigate } from "react-router-dom";


function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="app-footer">
      <div className="footer-columns">
        <div className="footer-column futsal-column">
          <h4>FUTSAL</h4>
          <ul>
            <li>BOOTS</li>
            <li>CLUBS</li>
            <li>BOOKS</li>
          </ul>
        </div>
        <div className="footer-column marketing-column">
          <h4>MAILING LIST</h4>
          <ul className="footer-list">
            <li>
              <button
                className="footer-sign-up-button"
                onClick={() => navigate("/about")}
                role="link"
              >
                SIGN UP
              </button>
            </li>
            <li>
              <a href="/about">
                JOIN OUR MAILING LIST TO STAY UP TO DATE WITH EVERYTHING FUTSAL
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>FOLLOW US</h4>
          <ul>
            <li>
              <a href="https://www.tiktok.com/@thefutsaldirectory" target="_blank" rel="noopener noreferrer">
                TIKTOK
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/thefutsaldirectory?igsh=MWZ3YWJ5dm9sbDMwZA==" target="_blank" rel="noopener noreferrer">
                INSTAGRAM
              </a>
            </li>
            <li>
              <a href="https://x.com/futsaldirectory" target="_blank" rel="noopener noreferrer">
                X
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@TheFutsalDirectory" target="_blank" rel="noopener noreferrer">
                YOUTUBE
              </a>
            </li>
          </ul>

        </div>
      </div>

      {/* New Section Below */}
      <div className="footer-bottom">
        <p className="tiny">© 2025 The Futsal Directory</p>
        <p className="site-credit">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
          <a href="/cookie-settings">Cookie Settings</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
